module.exports = __webpack_public_path__ + "img/pequeno-principe.fde81eda.jpg";